import { useContext, useEffect, useMemo, useRef, useState } from "react";
import ConditionalRender from "../../../../../ConditionalRender";
import { Button } from "../../../../cta_utils/AnButton";
import { AnInputCheckBox } from "../../../../input_utils/AnInputCheckBox";
import { indexOfObject } from "../../../../utils/ArrayUtils";
import { LoaderComponent } from "../../../../utils/LoaderComponent";
import humanizeString from "../../../../utils/stringUtils";
import AggregatesListContext from "./aggregates_list_context";
import Icon from "../../../../utils/Icon";

import { fetchAggregates } from "../../../aggregates/apiHitter";
import { setState } from "../../../../utils/CommonReducer";
import { get_data_params } from "../../../../views/news_feed/utils/newsFeedUtils";

const DEFAULT_AGG_SIZE = 20
const MAX_AGG_SIZE = 1000
export const AggregatesList = ({showsearchedRes, ...props}) => { 
    const { currfilterState, setCurrFilterState, filterTab, isLoading, allFilterTabs, tagsList, type} = useContext(AggregatesListContext);
    const {loadMore, data_params, filtersSelected} = currfilterState
    const mappedKey = filterTab.tab_key
    const filterType = 'include';
    const fetch_aggregates = (agg_size = null) => {
        let loader = loadMore ? "loadMoreLoader" : "tagsListLoader"
        setState(setCurrFilterState)({isLoading: {[loader]: true}})
        let final_data_params = {...data_params, ...get_data_params(type, {filtersState: currfilterState, allFilterTabs: allFilterTabs})}
        final_data_params.term = filterTab.is_custom ? 'custom_answers' : mappedKey
        if(agg_size)
            final_data_params.agg_size = agg_size 
        fetchAggregates(final_data_params, type).then((result) => {
            setCurrFilterState({type: "ASSIGN_AGGREGATES_DATA", payload: {aggregates: result.data.aggregates, filterType: filterType}})
            setState(setCurrFilterState)({isLoading: {[loader]: false}})
        }).catch((err)=> {
            setState(setCurrFilterState)({isLoading: {[loader]: false}})
        })
    }
    useEffect(() => {
        fetch_aggregates();
        setState(setCurrFilterState)({loadMore: false})
    }, [mappedKey])
    useEffect(() => {
        if(loadMore)
        fetch_aggregates(1000);
    }, [loadMore])
    const handleTagsChange = (e, item) => {
        let val = e.target.value
        setCurrFilterState({
            type: "SELECTED_FILTER",
            payload: { 
                mappedKey: mappedKey,
                filterType: filterType, 
                selectedVal: val,
                selectedAgg: item
            },
        });
    }
    return (
        <div className={tagsList.length === 0 ? "default_flex_container" : ""} style={{marginTop: 16, height: 280, overflowY: 'scroll', justifyContent: 'center'}}>
            <ConditionalRender if={isLoading.tagsListLoader}>
                <LoaderComponent isLoading={true}></LoaderComponent>
            </ConditionalRender>
            <ConditionalRender if={!isLoading.tagsListLoader}>
                {tagsList.length > 0 ?
                <div style={{  padding: '0px 0px 8px' }}>
                    {
                        tagsList.map((item, index) => {
                            if (!item.term) return null;
                            return (
                                <div key={item.term + index}>
                                    <AnInputCheckBox
                                        label={`${humanizeString(item.term)} ${item.count ? ("(" + item.count + ")") : ""}`}
                                        isChecked={item.is_checked}
                                        style={{ marginBottom: '8px' }}
                                    >
                                        <input type="checkbox" checked={item.is_checked} value={item.term} disabled={item.applied || item.disabled}
                                            onChange={(e) => handleTagsChange(e, item)}
                                        />
                                    </AnInputCheckBox>
                                </div>
                            )
                        })
                    } 
                    {
                        isLoading.loadMoreLoader ? 
                        <LoaderComponent loaderStyle={{width: 32, display: 'block', margin: '8px auto'}} isLoading={true}></LoaderComponent> :
                        tagsList.length === MAX_AGG_SIZE ? 
                            <div className="text_body_light">This is a partial list. Use search to refine further.</div> :
                            <ConditionalRender if={!loadMore && tagsList.length >= DEFAULT_AGG_SIZE}>
                            <div className="text_body_light" style={{cursor: 'pointer'}} onClick={() => setState(setCurrFilterState)({loadMore: true})}><span style={{textDecoration: 'underline'}}>Load More</span> ...</div>
                            </ConditionalRender>
                    }
                </div> :
                <div className="text_center">
                    <div><Icon name="SearchLensSad" style={{width: 34, height: 42}}/></div>
                    <div className="text_subtitle" style={{marginTop: 12}}>{showsearchedRes ? "No results match your search criteria" : "No results available"}</div>
                </div>}
            </ConditionalRender>
        </div>
    )
}